import type { DefaultOptions } from '@tanstack/react-query'
import { QueryClient } from '@tanstack/react-query'

const DEFAULTS: DefaultOptions = {
  queries: {
    // The underlying data changes at most once per nightly snapshot run.
    staleTime: 5 * 60 * 1000,
    // Off for the figures, and turned back on for the session query alone: a
    // tab coming back is not news about anybody's money, and it is the moment
    // a session is most likely to have gone.
    refetchOnWindowFocus: false,
  },
}

/**
 * The client the browser gets, built here rather than in the entry point so a
 * test can mount the same one. A query that behaves differently under test
 * because the test's own client left a default alone proves nothing about the
 * app — and the defaults on this client are exactly what decides whether an
 * expired session is ever noticed.
 */
export function createQueryClient(overrides: DefaultOptions = {}): QueryClient {
  return new QueryClient({
    defaultOptions: { ...DEFAULTS, queries: { ...DEFAULTS.queries, ...overrides.queries } },
  })
}
